// Readme----------------------------------->>
// Make sure to remove type prop in textField
// How to Use
//     <TextField
//         label="react-number-format"
//         value={this.state.values.numberformat}
//         onChange={this.handleChange2}
//         name="numberformat"
//         id="formatted-numberformat-input"
//         InputProps={{
//             inputComponent: NumberFormatCustom,
//         }}
//     /> 


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

class NumberFormatCustom extends Component {
    render() {
        const { inputRef, onChange, ...other } = this.props;

        return (
            <NumericFormat
                {...other}
                getInputRef={inputRef}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: this.props.name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator
                isNumericString
            // prefix={prefix}
            />
        );
    }
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatCustom;
